import { BREADCRUMBS_ADD, BREADCRUMBS_REMOVE, BREADCRUMBS_UPDATE } from 'src/react/components/breadcrumbs/constants';
import State from 'src/react/components/breadcrumbs/types/State';
import Action from 'src/react/components/breadcrumbs/types/Action';

const reducer = (state: State = {
  crumbs: [],
}, action: Action): State => {
  switch (action.type) {
    case BREADCRUMBS_ADD:
      return {
        ...state,
        crumbs: [...state.crumbs, action.payload.crumb],
      };
    case BREADCRUMBS_UPDATE:
      return {
        ...state,
        crumbs: state.crumbs.map((crumb) => {
          if (crumb.id !== action.payload.crumb.id) {
            return crumb;
          }
          return { ...crumb, ...action.payload.crumb };
        }),
      };
    case BREADCRUMBS_REMOVE:
      return {
        ...state,
        crumbs: state.crumbs.filter((crumb) => crumb.id !== action.payload.id),
      };
    default:
      return state;
  }
};

export default reducer;
